<div fxFlex="100">
	<form [formGroup]="customerCtrl">
		<mat-form-field
			(click)="$event.stopPropagation()"
			*ngIf="useChips"
			[appearance]="appearance"
			[floatLabel]="floatLabel"
			class="{{ customCssClass }}"
			fxFlex="100"
		>
			<mat-chip-list #chipList>
				<mat-chip
					*ngIf="!utilService.isNullOrUndefined(customerSelected) && !isCustomerSearchEnabled"
					class="capitalize"
				>
					{{ !utilService.isNullOrUndefined(customerSelected.name) ? customerSelected.name : '' }}
					<mat-icon (click)="enableSearch()" class="primary-light-color" matChipRemove
						>cancel</mat-icon
					>
				</mat-chip>

				<input
					#customerInput
					(matChipInputTokenEnd)="add($event)"
					[disabled]="!isCustomerSearchEnabled"
					[formControl]="customerCtrl"
					[matAutocomplete]="auto"
					[matChipInputAddOnBlur]="addOnBlur"
					[matChipInputFor]="chipList"
					[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
					placeholder="Search by customer name"
				/>
			</mat-chip-list>
			<mat-autocomplete
				#auto="matAutocomplete"
				(optionSelected)="selected($event); customerInput.value = ''"
			>
				<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
					<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
				</mat-option>
				<mat-option
					*ngIf="
						!isLoading &&
						!utilService.isNullOrUndefined(customersList) &&
						customersList.length == 0 &&
						utilService.isNullOrUndefined(customerSelected)
					"
					fxLayoutAlign="center center"
				>
					No matching customer found. A new customer will be added.
				</mat-option>

				<ng-container *ngIf="!isLoading && utilService.isNullOrUndefined(customerSelected)">
					<mat-option
						*ngFor="let customer of customersList"
						[value]="customer.id"
						class="capitalize"
					>
						{{ customer.name }}
					</mat-option>
				</ng-container>
			</mat-autocomplete>
		</mat-form-field>

		<mat-form-field
			(click)="$event.stopPropagation()"
			*ngIf="!useChips"
			[appearance]="appearance"
			[floatLabel]="floatLabel"
			class="{{ customCssClass }}"
			fxFlex="100"
		>
			<input
				(focus)="initializeList()"
				(keyup.enter)="addAndSetNewCustomer()"
				[formControl]="customerCtrl"
				[matAutocomplete]="auto"
				[placeholder]="placeholder"
				class="capitalize"
				matInput
			/>
			<mat-icon *ngIf="showInputWithIcon" class="vertical-align-middle" matSuffix
				>keyboard_arrow_down</mat-icon
			>
			<mat-autocomplete
				#auto="matAutocomplete"
				(optionSelected)="selected($event)"
				[displayWith]="displayFn"
			>
				<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
					<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
				</mat-option>

				<ng-container
					*ngIf="
						!isLoading && !utilService.isNullOrUndefined(customersList) && customersList.length == 0
					"
					fxLayoutAlign="center center"
				>
					<span (click)="addAndSetNewCustomer()" class="link p-1">Add New Customer</span>
				</ng-container>

				<ng-container *ngIf="!isLoading">
					<mat-option *ngFor="let customer of customersList" [value]="customer" class="capitalize">
						{{ customer.name }}
					</mat-option>
				</ng-container>
			</mat-autocomplete>
		</mat-form-field>
	</form>
</div>
